import React from 'react';

import { BuilderBlocks } from '@builder.io/react';
import PropTypes from 'prop-types';

import { getBuilderMembershipStatus } from '~/builder/utils/getBuilderMembershipStatus';
import useGender from '~/shared/utils/useGender';
import { useMembership } from '~/techstyle-shared/react-accounts';
import { useIntl } from '~/techstyle-shared/react-intl';
import { useMarketingDisposition } from '~/techstyle-shared/react-marketing';
import { useSession } from '~/techstyle-shared/redux-core';

const BuilderTargetedSection = ({
  localeList,
  membershipStatusList,
  experienceIdList,
  genderList,
  builderBlock,
}) => {
  const { locale } = useIntl();
  const { isLoggedIn } = useSession();
  const membership = useMembership();
  const membershipStatus = getBuilderMembershipStatus(membership, isLoggedIn);
  const disposition = useMarketingDisposition();
  const experienceId = disposition?.experience;
  const { gender } = useGender();

  // check whether we should show the content
  const showContent =
    Boolean(
      !membershipStatusList?.length ||
        membershipStatusList?.includes(membershipStatus)
    ) &&
    Boolean(!localeList?.length || localeList?.includes(locale)) &&
    Boolean(
      !experienceIdList?.length || experienceIdList?.includes(experienceId)
    ) &&
    Boolean(!genderList?.length || genderList?.includes(gender));

  return (
    <>
      {showContent && builderBlock?.children?.length > 0 && (
        <BuilderBlocks
          parentElementId={builderBlock.id}
          blocks={builderBlock.children}
        />
      )}
    </>
  );
};

BuilderTargetedSection.propTypes = {
  builderBlock: PropTypes.object,
  experienceIdList: PropTypes.array,
  genderList: PropTypes.array,
  localeList: PropTypes.array,
  membershipStatusList: PropTypes.array,
};

export default BuilderTargetedSection;
